<div class="modal-header bg-primary">
  <h4 class="modal-title text-white"><i class="fa-light fa-download me-1"></i>Explore and download</h4>
</div>
<div class="modal-body">
  <div class="d-flex justify-content-center align-items-center">
    <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
    Preparing data to be downloaded...
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="modal.dismiss('Dismiss request')">
    Cancel request
  </button>
</div>
